<template>
  <div id="pk-result">
      <div class="award-tab-wrapper">
          <button :class="awardType === 'team' ? 'active' : ''" @click="awardType = 'team'">团队奖项</button>
          <button :class="awardType === 'person' ? 'active' : ''" @click="awardType = 'person'">个人奖项</button>
      </div>
      <div v-show="awardType === 'team'" class="team">
        <p class="intro">团队奖项将在活动结束后的次日开奖，活动期间会进行结果的预统计，以便战队成员了解最新的战况。 <br/>奖励将在开奖当日的18：00前发放，请您耐心等待。</p>
        <div class="award-info-team">
              <h2 v-if="teamTime !== 0" class="time">开奖时间：{{ teamTime | parseTime}}</h2>
              <div v-else class="title-box">
                <img src="@/assets/active/team-pk/title-tag.png" alt="">
                <span>当前预计统计结果</span>
                <img src="@/assets/active/team-pk/title-tag.png" alt="">
              </div>
              <div class="award-card">
                  <div class="card-head card-row">
                    <span class="rank">名次</span>
                    <span class="name">获奖者</span>
                    <span class="content">个人奖励</span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk/result/first.png" alt="">
                        </div>
                        <h3>一等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <p class="team-name">{{ teamObj.one.name }}</p>
                        </div>
                    </span>
                    <span class="content">
                        <p v-html="teamObj.one.content"></p>
                    </span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk/result/second.png" alt="">
                        </div>
                        <h3>二等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <p class="team-name">{{ teamObj.two ? teamObj.two.name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content">
                        <p v-html="teamObj.two ? teamObj.two.content : '-'"></p>
                    </span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk/result/third.png" alt="">
                        </div>
                        <h3>三等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <p class="team-name">{{ teamObj.three ? teamObj.three.name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content">
                        <p v-html="teamObj.three ? teamObj.three.content : '-'"></p>
                    </span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk/result/fourth.png" alt="">
                        </div>
                        <h3>安慰奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <p class="team-name">{{ teamObj.four ? teamObj.four.name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content">
                        <p v-html="teamObj.four ? teamObj.four.content : '-'"></p>
                    </span>
                  </div>
                  <div class="line first"></div>
                  <div class="line second"></div>
              </div>
          </div>
      </div>
      <div v-show="awardType === 'person'" class="person">
          <p class="intro">个人奖项将在活动期间每日开奖，所有战队成员均有机会获得，敬请关注！ <br/>奖励将在开奖当日的18：00前发放，请您耐心等待。</p>
          <div class="award-info-person" v-for="dateAward in personList" :key="dateAward.date">
              <h2 class="time">开奖时间：{{ dateAward.date | parseTime }}</h2>
              <div class="award-card">
                  <div class="card-head card-row">
                    <span class="rank">名次</span>
                    <span class="name">获奖者</span>
                    <span class="content">个人奖励</span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk/result/first.png" alt="">
                        </div>
                        <h3>一等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <img class="ava" :src="dateAward['1'] ? dateAward['1'].head : defaultImg " alt="">
                            <p class="id">{{ dateAward['1'] ? dateAward['1'].id : '-' }}</p>
                            <p class="nick">{{ dateAward['1'] ? dateAward['1'].name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content" v-html="dateAward['1'] ? dateAward['1'].content : '-'"></span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk/result/second.png" alt="">
                        </div>
                        <h3>二等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <img class="ava" :src="dateAward['2'] ? dateAward['2'].head : defaultImg " alt="">
                            <p class="id">{{ dateAward['2'] ? dateAward['2'].id : '-' }}</p>
                            <p class="nick">{{ dateAward['2'] ? dateAward['2'].name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content" v-html="dateAward['2'] ? dateAward['2'].content : '-'"></span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk/result/third.png" alt="">
                        </div>
                        <h3>三等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <img class="ava" :src="dateAward['3'] ? dateAward['3'].head : defaultImg " alt="">
                            <p class="id">{{ dateAward['3'] ? dateAward['3'].id : '-' }}</p>
                            <p class="nick">{{ dateAward['3'] ? dateAward['3'].name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content" v-html="dateAward['3'] ? dateAward['3'].content : '-'"></span>
                  </div>
                  <div class="line first"></div>
                  <div class="line second"></div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { parseTime } from '@/commons/tools.js'
export default {
    name: 'TeamPkResult',
    data() {
        return {
            awardType: 'team',
            teamTime: null,
            teamObj: {},
            personList: []
        }
    },
    watch: {
        awardType(newVal) {
            this.getResult()
        }
    },
    computed: {
        defaultImg() { return this.$DefaultHead }
    },
    mounted() {
        this.actId = this.$route.query.actId ? this.$route.query.actId : '252751'
        this.getResult()
    },
    methods: {
        getResult() {
            //  获取赛况直播内容
            this.$MyAxios.get('/api/trade/teams/award', {
                params: {
                    actId: this.actId,
                    ownerType: this.awardType === 'team' ? 'A' : 'B'
                }
            }, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    if(this.awardType === 'team'){
                        let teamAward = response.data[0]
                        this.teamTime = parseInt(teamAward.date)
                        this.setTeamData(teamAward)
                    } else {
                        let personAward = response.data
                        personAward = personAward.sort((a, b) => {
                            return parseInt(b.date) - parseInt(a.date)
                        })
                        this.setPersonData(personAward)
                    }
                }
            })
        },
        //  设置团队奖项
        setTeamData(teamAward) {
            let contentObj = teamAward.content
            const resultObj = {}
            for(let i = 0; i < contentObj.length; i++){
                const obj = contentObj[i]
                if(obj.level == -1) {
                    resultObj['four'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                } else if (obj.level == 1) {
                    resultObj['one'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                } else if (obj.level == 2) {
                    resultObj['two'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                } else {
                    resultObj['three'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                }
            }
            this.teamObj = resultObj
        },
        //  设置个人奖项
        setPersonData(personList) {
            const personResultList = []
            for(let i = 0; i < personList.length; i++) {
                const personObj = personList[i]
                const personResultObj = {}
                const personContent = personObj.content
                for(let i = 0; i < personContent.length; i++){
                    const obj = personContent[i]
                    personResultObj[obj.level] = {
                        id: obj.memberInfo && obj.memberInfo.jgzUserId ? obj.memberInfo.jgzUserId : '-',
                        name: obj.memberInfo && obj.memberInfo.nickName ? obj.memberInfo.nickName : '-',
                        head: obj.memberInfo && obj.memberInfo.headImg ? obj.memberInfo.headImg : this.defaultImg,
                        content: obj.content
                    }
                }
                personResultObj['date'] = personObj.date
                personResultList.push(personResultObj)
            }
            this.personList = personResultList
        },
        parseTime(time) {
            return parseTime(time)
        }
    }
}
</script>

<style lang="less" scoped>
#pk-result {
    padding-bottom: 278px;
}
.award-tab-wrapper {
    height: 88px;
    width: 600px;
    border-radius: 88px;
    background: #EBECF0;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 30px;
    button {
        border: none;
        background-color: #EBECF0;
        outline: none;
        color: #9598A6;
        font-size: 32px;
        font-weight: bold;
        height: 88px;
        width: 300px;
        border-radius: 88px;
        &.active {
            background: linear-gradient(180deg,#ffa41f, #ff5c2a);
            color: #FFFFFF;
        }
    }
}
.intro {
    line-height: 48px;
    font-size: 28px;
    color: #33333A;
    padding: 0 30px;
    margin-bottom: 30px;
    text-align: left;
}
.person {
    padding-bottom: 10px;
    .award-info-person {
        padding: 0 30px;
        .time {
            font-size: 28px;
            line-height: 38px;
            margin-bottom: 10px;
            text-align: left;
            font-weight: bold;
        }
    }
    .award-card {
        height: 370px;
    }
    .card-body {
        height: 100px;
    }
    .rank {
       width: 160px;
       img {
           height: 42px;
           width: 42px;
       }
       h3 {
           font-size: 24px;
           line-height: 36px;
       } 
    }
    .name {
        width: 320px;
        color: #33333A;
        &>div {
            height: 72px;
            position: relative;
            padding-left: 80px;
            text-align: left;
        }
        img {
            position: absolute;
            top: 6px;
            left: 5px;
            height: 60px;
            width: 60px;
            border-radius: 30px;
        }
        p {
            font-size: 24px;
            line-height: 36px;
        }
        .nick {
            font-weight: bold;
        }
    }
    .content {
        width: 210px;
    }
    .line {
        &.first {
            left: 159px;
        }
        &.second {
            left: 479px;
        }
    }
}
.team {
    padding-bottom: 10px;
    .award-info-team {
        padding: 0 30px;
        .time {
            font-size: 32px;
            line-height: 36px;
            margin-bottom: 30px;
            text-align: center;
            color: #ffa41f;
            font-weight: bold;
        }
        .title-box {
            height: 40px;
            line-height: 40px;
            text-align: center;
            margin-bottom: 30px;
            img, span {
                vertical-align: middle;
            }
            img {
                margin: 0 5px;
                width: 44px;
                height: 24px;
            }
            span {
                font-size: 32px;
                color: #33333A;
                font-weight: bold;
            }
        }
    }
    .award-card {
        height: 630px;
    }
    .card-body {
        height: 140px;
    }
    .rank {
       width: 160px;
       img {
           height: 42px;
           width: 42px;
       }
       h3 {
           font-size: 24px;
           line-height: 36px;
       } 
    }
    .name {
        width: 260px;
        color: #33333A;
        p {
            font-size: 24px;
            line-height: 36px;
            font-weight: bold;
        }
        .nick {
            font-weight: bold;
        }
    }
    .content {
        width: 270px;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
    }
    .line {
        &.first {
            left: 159px;
        }
        &.second {
            left: 419px;
        }
    }
}
.award-card {
    width: 690px;
    margin: 0 auto;
    border: 1px solid #FFA41F;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 60px;
    position: relative;
    .card-row {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #FFA41F;
        &:last-child {
            border-bottom: 0;
        }
        &>span {
            flex-grow: 1;
        }
    }
    .card-head {
        height: 70px;
        background: #FFF6E8;
        color: #33333A;
        font-size: 28px;
    }
    .line {
        position: absolute;
        height: 100%;
        width: 1px;
        background: #FFA41F;
        top: 0;
    }
}
</style>